import { render, staticRenderFns } from "./VideoCutting.vue?vue&type=template&id=2fb7467a&scoped=true&"
import script from "./VideoCutting.vue?vue&type=script&lang=js&"
export * from "./VideoCutting.vue?vue&type=script&lang=js&"
import style0 from "./VideoCutting.vue?vue&type=style&index=0&id=2fb7467a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb7467a",
  null
  
)

export default component.exports